//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";


import addressBox from '@/components/ui/addressBox'
import rollBox from '@/components/ui/rollBox'

export default {
    name: 'test',

    components: {
        addressBox,rollBox
    },

    data(){
        return {
            dialog: false,

        }
    },
    methods:{
        onfinish(arr){
            console.log(arr);
        }
    },
    mounted(){


    },
}



// WEBPACK FOOTER //
// ./src/views/test.vue